module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"comments:no-comments":"Комментарии отсутствуют","comments:placeholder":"Текст комментария"},"en":{"comments:no-comments":"No comments","comments:placeholder":"Comment text"}}')
  delete Component.options._Ctor
}
